import React from "react";
import NewsGrid from "../components/NewsGrid";

export default function Noticias() {
  return (
    <div data-testid="page-noticias" className="pt-24 md:pt-32 bg-[#FAF9F6]">
      <header className="max-w-7xl mx-auto px-6 md:px-10 pb-10 md:pb-12">
        <div className="text-[11px] uppercase tracking-[0.28em] text-[#003F88] font-semibold">
          <span className="accent-line" />
          Notícias & atualizações
        </div>
        <h1 className="font-serif-display text-5xl md:text-7xl leading-[0.95] tracking-tight mt-6">
          O que está <em className="italic font-light">acontecendo</em>.
        </h1>
      </header>
      <NewsGrid />
    </div>
  );
}
